import React from 'react';
import styled from 'styled-components';

// Task 30 — "bulgular" (360 özeti + hedef sonuçları) render'ı hem
// CalibrationManagerPage'in detay modalında (yorumlar + OverallLevel DAHİL —
// yönetici görünümü) hem MyCalibrationPage'de (yalnız sayısal — çalışan
// görünümü) tekrar kullanılır. Bu dosya, aynı feature klasörü içinde iki
// tüketici arasındaki paylaşımı ifade eder (DecisionRadio.js'in period-goals
// klasöründeki rolüyle aynı ilke) — MyPeriodResultsPage'in kendi
// GoalsTabContent/FeedbackTabContent'inin BAĞIMSIZ bir kopyasıdır (Task 29'un
// "bağımsız kopya" konvansiyonu — o dosyaya bağımlılık kurulmaz, yalnız aynı
// görsel dil tekrarlanır).
const GoalCard = styled.div`
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
`;

const GoalCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

const GoalTypeBadge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  background: #eff6ff;
  color: #0291ef;
`;

const GoalTitle = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 4px;

  th, td {
    text-align: left;
    padding: 8px 10px;
    font-size: ${({ theme }) => theme.metrics.font.size.sm};
    border-bottom: 1px solid #f1f5f9;
  }

  th {
    color: ${({ theme }) => theme.colors.text.dark.little};
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  }

  td {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const KpiField = styled.div``;

const KpiLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-bottom: 4px;
`;

const KpiValue = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
`;

const EmptyText = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const SectionTitle = styled.h4`
  margin: 0 0 12px;
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const WeightedOverallCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 16px;
`;

const WeightedOverallLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
`;

const WeightedOverallValue = styled.div`
  font-size: 22px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.primary.main};
`;

const CommentList = styled.ul`
  margin: 4px 0 0;
  padding-left: 18px;
`;

export function GoalResultsSection({ goals, t }) {
  return (
    <div>
      <SectionTitle>{t('performance.calibration.goalResultsTitle')}</SectionTitle>
      {(!goals || goals.length === 0) ? (
        <EmptyText>{t('performance.goal.noGoals')}</EmptyText>
      ) : (
        goals.map((goal) => (
          <GoalCard key={goal.id}>
            <GoalCardHeader>
              <GoalTypeBadge>{t(`performance.goal.goalType.${goal.goalType}`, { defaultValue: goal.goalType })}</GoalTypeBadge>
              <GoalTitle>{goal.title}</GoalTitle>
            </GoalCardHeader>

            {goal.goalType === 'okr' ? (
              <StyledTable>
                <thead>
                  <tr>
                    <th>{t('performance.goal.keyResultTitle')}</th>
                    <th>{t('performance.goal.employeeScore')}</th>
                    <th>{t('performance.goal.managerScore')}</th>
                  </tr>
                </thead>
                <tbody>
                  {(goal.keyResults || []).map((kr) => (
                    <tr key={kr.id}>
                      <td>{kr.title}</td>
                      <td>{kr.employeeScore ?? '-'}</td>
                      <td>{kr.managerScore ?? '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </StyledTable>
            ) : (
              <KpiGrid>
                <KpiField>
                  <KpiLabel>{t('performance.goal.kpiIndicatorName')}</KpiLabel>
                  <KpiValue>{goal.kpiIndicatorName || '-'}</KpiValue>
                </KpiField>
                <KpiField>
                  <KpiLabel>{t('performance.goal.kpiTargetValue')}</KpiLabel>
                  <KpiValue>{goal.kpiTargetValue ?? '-'}</KpiValue>
                </KpiField>
                <KpiField>
                  <KpiLabel>{t('performance.goal.kpiCompletionPct')}</KpiLabel>
                  <KpiValue>{goal.completionPct != null ? `${goal.completionPct}%` : '-'}</KpiValue>
                </KpiField>
              </KpiGrid>
            )}
          </GoalCard>
        ))
      )}
    </div>
  );
}

// showComments — yalnız yönetici görünümünde true (ManagerFeedbackSummaryDto
// Comments + OverallLevel taşır); çalışan görünümünde (EmployeeFeedbackSummaryDto)
// bu alanlar TİP DÜZEYİNDE yok — showComments=false iken zaten hiç okunmaz.
export function FeedbackSummarySection({ summary, showComments, t }) {
  return (
    <div>
      <SectionTitle>{t('performance.calibration.feedbackSummaryTitle')}</SectionTitle>
      {!summary ? (
        <EmptyText>{t('performance.calibration.feedbackNotAvailable')}</EmptyText>
      ) : (
        <>
          <WeightedOverallCard>
            <WeightedOverallLabel>{t('performance.results.weightedOverall')}</WeightedOverallLabel>
            <WeightedOverallValue>{summary.weightedOverall != null ? summary.weightedOverall : '-'}</WeightedOverallValue>
          </WeightedOverallCard>

          {showComments && summary.overallLevelLabel && (
            <EmptyText style={{ marginBottom: 12 }}>
              <strong>{t('performance.calibration.feedbackOverallLevel')}:</strong>{' '}
              {summary.overallLevelLabel}
            </EmptyText>
          )}

          {(!summary.perQuestion || summary.perQuestion.length === 0) ? (
            <EmptyText>{t('performance.results.noQuestions')}</EmptyText>
          ) : (
            <StyledTable>
              <thead>
                <tr>
                  <th>{t('performance.results.question')}</th>
                  <th>{t('performance.results.average')}</th>
                </tr>
              </thead>
              <tbody>
                {summary.perQuestion.map((q) => (
                  <tr key={q.questionId}>
                    <td>
                      {q.text}
                      {showComments && q.comments && q.comments.length > 0 && (
                        <CommentList>
                          {q.comments.map((c, i) => <li key={i}>{c}</li>)}
                        </CommentList>
                      )}
                    </td>
                    <td>{q.average != null ? q.average : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          )}
        </>
      )}
    </div>
  );
}
